import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-copy-content-dialog',
  templateUrl: './copy-content-dialog.component.html',
  styleUrls: ['./copy-content-dialog.component.scss']
})
export class CopyContentDialogComponent implements OnInit {
  contentToBeCopy: string;
  constructor(
    private dialogRef: MatDialogRef<CopyContentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public notifier: NotifierService) { 
      this.contentToBeCopy = data.content;
    }

  ngOnInit(): void {
  }
  onCopy() {
    let copyText = document.getElementById("currentlyHiddenTextareaId") as HTMLInputElement;
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(copyText.value);
    this.notifier.notify('success','Copied to clipboard!');
}

close() {
  this.dialogRef.close();
}

}
